import {
    FORGOT_MFA,
    FORGOT_MFA_EMAIL,
    FORGOT_PASSWORD,
    INVITED_USER,
    LOGIN,
    MFA_SETUP,
    MFA_VERIFY,
    RESET_PASSWORD,
} from 'containers/urlConstant';

/**
 * Routes rendered by BaseRoute without a session. A session-ending event must not
 * navigate away from any of them, otherwise an expired background call could bounce
 * the user out of a form they are filling in (reset password, MFA verify, ...).
 */
export const AUTH_ROUTES = [
    LOGIN,
    FORGOT_PASSWORD,
    RESET_PASSWORD,
    INVITED_USER,
    MFA_SETUP,
    MFA_VERIFY,
    FORGOT_MFA,
    FORGOT_MFA_EMAIL,
];

/**
 * Pulls the route path out of the HashRouter hash, dropping the leading `#`
 * and any query string or nested hash.
 * `#/mfa/verify?token=abc` -> `/mfa/verify`
 */
export const getHashPath = () => {
    const hash = window.location.hash || '';
    const withoutHashSymbol = hash.startsWith('#') ? hash.slice(1) : hash;
    return withoutHashSymbol.split('?')[0].split('#')[0];
};

/**
 * True when the app currently sits on one of the unauthenticated routes.
 * The match is exact: every auth route in `BaseRoute` is declared `exact`, so a
 * deeper path such as `/mfa/verify/123` is not an auth route and must redirect.
 */
export const isOnAuthRoute = () => {
    const path = getHashPath();
    if (!path) {
        return false;
    }
    return AUTH_ROUTES.some((route) => path === route);
};

/**
 * Sends the user to the login screen after the session has ended.
 * Works outside React (axios interceptors) and keeps the page alive, so the
 * redux store - and with it the Toaster - survives the navigation.
 * `replace` rather than an assignment: the expired route must not stay in the
 * history, otherwise Back lands on it and is bounced straight forward again.
 * The target differs from the current URL only by its fragment, so the browser
 * navigates within the same document and never reloads the app.
 */
export const redirectToLogin = () => {
    if (isOnAuthRoute()) {
        return;
    }
    window.location.replace(`#${LOGIN}`);
};
